<template>
  <div class="col  mt-3">

    <div class="row">
      <div class="col-sm-12">
        <div class="row">

          <div class=" col-md-3 col-lg-3">

            <div class="card p-4">

              <div class="card-title text-center"><h4><b>{{$t("fatura.fatura")}}</b></h4></div>
              <apexchart type="radialBar" height=230 :options="options" :series="series"></apexchart>

            </div>

          </div>

          <div class=" col-md-3 col-lg-3">

            <div class="card p-4">

              <div class="card-title text-center"><h4><b>{{$t("fatura.odendi")}}</b></h4></div>
              <apexchart type="radialBar" height=230 :options="options1" :series="series1"></apexchart>

            </div>

          </div>

          <div class=" col-md-3 col-lg-3">

            <div class="card p-4">

              <div class="card-title text-center"><h4><b>{{$t("fatura.odenmedi")}}</b></h4></div>
              <apexchart type="radialBar" height=230 :options="options2" :series="series2"></apexchart>

            </div>

          </div>

          <div class=" col-md-3 col-lg-3">

            <div class="card p-4">

              <div class="card-title text-center"><h4><b>{{$t("fatura.gecikti")}}</b></h4></div>
              <apexchart type="radialBar" height=230 :options="options3" :series="series3"></apexchart>

            </div>

          </div>

        </div>
      </div>

    </div>


  </div>
</template>

<script>



  export default {
    data() {
      return {


        options: {
          chart: {
            toolbar: {
              show: false
            }
          },
          colors: ['#2e9dd2'],

          plotOptions: {


            radialBar: {


              hollow: {
                margin: 0,
                size: '90%',
                background: 'transparent',
                position: 'front',
                dropShadow: {
                  enabled: false,
                  top: 3,
                  left: 0,
                  blur: 4,
                  opacity: 0.24
                },

              },
              track: {
                background: '#fff',
                strokeWidth: '67%',
                margin: 0, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 0,
                  left: 0,
                  blur: 0,
                  opacity: 0.35
                },

              },

              dataLabels: {

                name: {
                  offsetY: -10,
                  show: false,
                  color: '#fff',
                  fontSize: '17px'
                },
                value: {
                  formatter: function (val) {
                    return parseInt(val);
                  },
                  color: '#111',
                  fontSize: '36px',
                  show: true,
                }
              }
            }
          },
          fill: {
            color: ['#000'],
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#000'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: 'round'
          },

          labels: [''],

        },

        options1: {
          chart: {
            toolbar: {
              show: false
            }
          },

          colors: ['#75b857'],
          plotOptions: {


            radialBar: {


              hollow: {
                margin: 0,
                size: '90%',
                background: 'transparent',
                position: 'front',
                dropShadow: {
                  enabled: false,
                  top: 3,
                  left: 0,
                  blur: 4,
                  opacity: 0.24
                },

              },
              track: {
                background: '#fff',
                strokeWidth: '67%',
                margin: 0, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 0,
                  left: 0,
                  blur: 0,
                  opacity: 0.35
                },

              },

              dataLabels: {

                name: {
                  offsetY: -10,
                  show: false,
                  color: '#fff',
                  fontSize: '17px'
                },
                value: {
                  formatter: function (val) {
                    return parseInt(val);
                  },
                  color: '#111',
                  fontSize: '36px',
                  show: true,
                }
              }
            }
          },
          fill: {
            color: ['#000'],
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#000'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: 'round'
          },

          labels: [''],

        },

        options2: {
          chart: {
            toolbar: {
              show: false
            }
          },

          colors: ['#c22552'],
          plotOptions: {


            radialBar: {


              hollow: {
                margin: 0,
                size: '90%',
                background: 'transparent',
                position: 'front',
                dropShadow: {
                  enabled: false,
                  top: 3,
                  left: 0,
                  blur: 4,
                  opacity: 0.24
                },

              },
              track: {
                background: '#fff',
                strokeWidth: '67%',
                margin: 0, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 0,
                  left: 0,
                  blur: 0,
                  opacity: 0.35
                },

              },

              dataLabels: {

                name: {
                  offsetY: -10,
                  show: false,
                  color: '#fff',
                  fontSize: '17px'
                },
                value: {
                  formatter: function (val) {
                    return parseInt(val);
                  },
                  color: '#111',
                  fontSize: '36px',
                  show: true,
                }
              }
            }
          },
          fill: {
            color: ['#000'],
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#000'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: 'round'
          },

          labels: [''],

        },


        options3: {
          chart: {
            toolbar: {
              show: false
            }
          },
          colors: ["#f6ee4b"],
          plotOptions: {


            radialBar: {


              hollow: {
                margin: 0,
                size: '90%',
                background: 'transparent',
                position: 'front',
                dropShadow: {
                  enabled: false,
                  top: 3,
                  left: 0,
                  blur: 4,
                  opacity: 0.24
                },

              },
              track: {
                background: '#fff',
                strokeWidth: '67%',
                margin: 0, // margin is in pixels
                dropShadow: {
                  enabled: true,
                  top: 0,
                  left: 0,
                  blur: 0,
                  opacity: 0.35
                },

              },

              dataLabels: {

                name: {
                  offsetY: -10,
                  show: false,
                  color: '#fff',
                  fontSize: '17px'
                },
                value: {
                  formatter: function (val) {
                    return parseInt(val);
                  },
                  color: '#111',
                  fontSize: '36px',
                  show: true,
                }
              }
            }
          },
          fill: {
            color: ['#000'],
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: ['#000'],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          stroke: {
            lineCap: 'round'
          },

          labels: [''],

        },


        series: [0],
        series1: [0],
        series2: [0],
        series3: [0],


        formLabelWidth: '180px',
      }
    },
    methods: {


      Bilgi() {
        this.$store.dispatch("dataver", {method: "get", url: "/bilgi/fatura"})
          .then(response => {
            this.series[0] = response.fatura;
            this.series1[0] = response.fodenen;
            this.series2[0] = response.fodenmeyen;
            this.series3[0] = response.fgeciken;
            console.log(response);
          });
      },


    },
    created() {
      this.Bilgi()

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/panel.vue